import { ReactElement, Suspense } from 'react';
import { Typography, Spin } from 'antd';
import { CurrentCapacityDisplay, CapacityNumber, CapacityValueContainer } from './styles';
import { useIsActive } from '../hooks/useIsActive';

const { Text } = Typography;

const CapacityValue = (): ReactElement => {
  const { users } = useIsActive();
  const totalCapacity = users.reduce((acc, cur) => acc + (cur.isActive ? 1 : 0), 0);

  return (
    <CapacityValueContainer>
      <CapacityNumber>{totalCapacity}</CapacityNumber>
      <Text> 件</Text>
    </CapacityValueContainer>
  );
};

const Summary = (): ReactElement => {
  return (
    <CurrentCapacityDisplay>
      <Text>合計モニター可能数</Text>
      <br />
      <Suspense
        fallback={
          <CapacityValueContainer>
            <Spin />
          </CapacityValueContainer>
        }
      >
        <CapacityValue />
      </Suspense>
    </CurrentCapacityDisplay>
  );
};

export default Summary;
